import type { FC } from "react";
import { ASSISTANT_AVATAR } from "../../../../../theme/tokens";

const { ACCESSORY } = ASSISTANT_AVATAR;

/** A steaming mug held at the lower right. Same placement for both styles. */
export const AvatarCoffee: FC = () => (
	<g transform="translate(88 82)">
		<rect x={0} y={6} width={18} height={19} rx={4} fill={ACCESSORY.COFFEE_CUP} stroke={ACCESSORY.INK} strokeWidth={2.2} />
		<rect x={0} y={12} width={18} height={5} fill={ACCESSORY.COFFEE} />
		<path d="M18 11 q7 0 7 5.5 q0 5.5 -7 5.5" fill="none" stroke={ACCESSORY.INK} strokeWidth={2.2} />
		<path d="M5 2 q-2.5 -3 0 -6" stroke={ACCESSORY.STEAM} strokeWidth={1.8} fill="none" strokeLinecap="round" />
		<path d="M12 2 q-2.5 -3 0 -6" stroke={ACCESSORY.STEAM} strokeWidth={1.8} fill="none" strokeLinecap="round" />
	</g>
);
